import React from 'react';
import moment from 'moment';

import { env } from '~/commons/config';

import ListResource from '../../lists/ListResource.jsx';

const ListRecords = ({ _id }) => (<ListResource
    {...{
      searchable: false,
      api: '/api/core/stocks/records',
      sort: { itemCode: 1 },
      filter: {
        target: _id || null,
      },
      actions: {
        create: false,
        remove: false,
      },
      onRowClick: () => null,
      cols: [
        {
          key: 'target.itemCode',
          sortable: true,
          children: 'Item Code',
        },
        {
          key: 'target.serialNo',
          sortable: true,
          children: 'Serial Nubmer',
        },
        {
          key: 'user',
          children: 'Action By',
          sortable: true,
          getter: (v, r) => (r.bySystem ? 'CMS Auto' : v?.username) || '',
        },
        {
          key: 'action',
          sortable: true,
        },
        {
          key: 'createdAt',
          children: 'Action At',
          sortable: true,
          getter: (v) => moment(v).format(env.f.dt),
        },
        {
          key: 'createdAt1',
          children: 'Auto Release Date',
          getter: (v, r) => (
            r.action === 'OnHold'
              ? moment(r.createdAt).add(7, 'days').endOf('date').format(env.f.d)
              : ''
          ),
        },
      ],
    }}
  />);

export default ListRecords;
